import React from 'react'

import { Collapse } from '@infotech/base-components'

import { IssueLinkInfoblock } from './IssueLinkSelect/components/IssueLinkInfoblock'


export const IssueLinkCollapseWidget = ({
  issueLink,
  issueLinkSystemType,
}) => (
  <Collapse title="Связанная заявка" isOpen>
    <div className="collapses-container">
      <IssueLinkInfoblock
        showUser
        issueLink={issueLink}
        showEmptyDate
        issueLinkSystemType={issueLinkSystemType}
      />
    </div>
  </Collapse>
)
